import React from "react";

const SettingsSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Currency Settings Skeleton */}
      <div className="border-border bg-card overflow-hidden rounded-lg border shadow-sm">
        {/* Category Header Skeleton */}
        <div className="p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="bg-muted h-10 w-10 animate-pulse rounded-lg p-2 motion-reduce:animate-none">
                <div className="bg-muted-foreground/20 h-5 w-5 rounded"></div>
              </div>
              <div>
                <div className="bg-muted mb-2 h-6 w-48 animate-pulse rounded motion-reduce:animate-none"></div>
                <div className="bg-muted h-4 w-64 animate-pulse rounded motion-reduce:animate-none"></div>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="bg-muted h-6 w-6 animate-pulse rounded motion-reduce:animate-none"></div>
              <div className="bg-muted h-5 w-5 animate-pulse rounded motion-reduce:animate-none"></div>
            </div>
          </div>
        </div>

        {/* Configs Skeleton */}
        <div className="border-border space-y-4 border-t p-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              className="border-border bg-background rounded-lg border p-4"
            >
              <div className="mb-3 flex items-start justify-between">
                <div className="flex-1">
                  <div className="mb-1 flex items-center space-x-2">
                    <div className="bg-muted h-4 w-32 animate-pulse rounded motion-reduce:animate-none"></div>
                  </div>
                  <div className="bg-muted mb-2 h-3 w-48 animate-pulse rounded motion-reduce:animate-none"></div>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="bg-muted h-6 w-16 animate-pulse rounded motion-reduce:animate-none"></div>
                  <div className="bg-muted h-6 w-12 animate-pulse rounded motion-reduce:animate-none"></div>
                </div>
              </div>
              <div className="bg-muted h-9 animate-pulse rounded motion-reduce:animate-none"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Distance Settings Skeleton */}
      <div className="border-border bg-card overflow-hidden rounded-lg border shadow-sm">
        <div className="p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="bg-muted h-10 w-10 animate-pulse rounded-lg p-2 motion-reduce:animate-none">
                <div className="bg-muted-foreground/20 h-5 w-5 rounded"></div>
              </div>
              <div>
                <div className="bg-muted mb-2 h-6 w-40 animate-pulse rounded motion-reduce:animate-none"></div>
                <div className="bg-muted h-4 w-56 animate-pulse rounded motion-reduce:animate-none"></div>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="bg-muted h-6 w-6 animate-pulse rounded motion-reduce:animate-none"></div>
              <div className="bg-muted h-5 w-5 animate-pulse rounded motion-reduce:animate-none"></div>
            </div>
          </div>
        </div>

        <div className="border-border space-y-4 border-t p-4">
          {[1, 2].map((i) => (
            <div
              key={i}
              className="border-border bg-background rounded-lg border p-4"
            >
              <div className="mb-3 flex items-start justify-between">
                <div className="flex-1">
                  <div className="mb-1 flex items-center space-x-2">
                    <div className="bg-muted h-4 w-28 animate-pulse rounded motion-reduce:animate-none"></div>
                  </div>
                  <div className="bg-muted mb-2 h-3 w-44 animate-pulse rounded motion-reduce:animate-none"></div>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="bg-muted h-6 w-16 animate-pulse rounded motion-reduce:animate-none"></div>
                  <div className="bg-muted h-6 w-12 animate-pulse rounded motion-reduce:animate-none"></div>
                </div>
              </div>
              <div className="bg-muted h-9 animate-pulse rounded motion-reduce:animate-none"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Date Time Settings Skeleton */}
      <div className="border-border bg-card overflow-hidden rounded-lg border shadow-sm">
        <div className="p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="bg-muted h-10 w-10 animate-pulse rounded-lg p-2 motion-reduce:animate-none">
                <div className="bg-muted-foreground/20 h-5 w-5 rounded"></div>
              </div>
              <div>
                <div className="bg-muted mb-2 h-6 w-36 animate-pulse rounded motion-reduce:animate-none"></div>
                <div className="bg-muted h-4 w-60 animate-pulse rounded motion-reduce:animate-none"></div>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="bg-muted h-6 w-6 animate-pulse rounded motion-reduce:animate-none"></div>
              <div className="bg-muted h-5 w-5 animate-pulse rounded motion-reduce:animate-none"></div>
            </div>
          </div>
        </div>

        <div className="border-border space-y-4 border-t p-4">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="border-border bg-background rounded-lg border p-4"
            >
              <div className="mb-3 flex items-start justify-between">
                <div className="flex-1">
                  <div className="mb-1 flex items-center space-x-2">
                    <div className="bg-muted h-4 w-24 animate-pulse rounded motion-reduce:animate-none"></div>
                  </div>
                  <div className="bg-muted mb-2 h-3 w-52 animate-pulse rounded motion-reduce:animate-none"></div>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="bg-muted h-6 w-16 animate-pulse rounded motion-reduce:animate-none"></div>
                  <div className="bg-muted h-6 w-12 animate-pulse rounded motion-reduce:animate-none"></div>
                </div>
              </div>
              <div className="bg-muted h-9 animate-pulse rounded motion-reduce:animate-none"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SettingsSkeleton;
